module.exports = __webpack_public_path__ + "img/chrome.e17d5224.png";